"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _method = _interopRequireDefault(require("./create/method"));

var _param = _interopRequireDefault(require("./create/param"));

// Copyright 2017-2019 @polkadot/jsonrpc authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
// NOTE Order is the same as in Rust
const getHeader = {
  description: 'Retrieves the header for a specific block',
  params: [(0, _param.default)('hash', 'Hash', {
    isOptional: true
  })],
  type: 'Header'
};
const getBlock = {
  description: 'Get header and body of a relay chain block',
  params: [(0, _param.default)('hash', 'Hash', {
    isOptional: true
  })],
  type: 'SignedBlock'
};
const getBlockHash = {
  description: 'Get the block hash for a specific block',
  params: [(0, _param.default)('blockNumber', 'BlockNumber', {
    isOptional: true
  })],
  type: 'Hash'
};
const getFinalizedHead = {
  description: 'Get hash of the last finalised block in the canon chain',
  params: [],
  type: 'Hash'
};
const getRuntimeVersion = {
  description: 'Get the runtime version (alias of state_getRuntimeVersion)',
  params: [(0, _param.default)('hash', 'Hash', {
    isOptional: true
  })],
  type: 'RuntimeVersion'
};
const subscribeNewHead = {
  description: 'Retrieves the best header via subscription',
  params: [],
  pubsub: ['newHead', 'subscribeNewHead', 'unsubscribeNewHead'],
  type: 'Header'
};
const subscribeFinalizedHeads = {
  description: 'Retrieves the best finalized header via subscription',
  params: [],
  pubsub: ['finalizedHead', // TODO US spelling
  'subscribeFinalisedHeads', 'unsubscribeFinalisedHeads'],
  type: 'Header'
};
const subscribeRuntimeVersion = {
  description: 'Retrieves the runtime version via subscription',
  params: [],
  pubsub: ['runtimeVersion', 'subscribeRuntimeVersion', 'unsubscribeRuntimeVersion'],
  type: 'RuntimeVersion'
};
const section = 'chain';
/**
 * @summary Methods to retrieve chain data.
 */

var _default = {
  isDeprecated: false,
  isHidden: false,
  description: 'Retrieval of chain data',
  section,
  methods: {
    getBlock: (0, _method.default)(section, 'getBlock', getBlock),
    getBlockHash: (0, _method.default)(section, 'getBlockHash', getBlockHash),
    // TODO US spelling
    getFinalizedHead: (0, _method.default)(section, 'getFinalisedHead', getFinalizedHead),
    getHeader: (0, _method.default)(section, 'getHeader', getHeader),
    getRuntimeVersion: (0, _method.default)(section, 'getRuntimeVersion', getRuntimeVersion),
    // TODO US spelling
    subscribeFinalizedHeads: (0, _method.default)(section, 'subscribeFinalisedHeads', subscribeFinalizedHeads),
    subscribeRuntimeVersion: (0, _method.default)(section, 'subscribeRuntimeVersion', subscribeRuntimeVersion),
    subscribeNewHead: (0, _method.default)(section, 'subscribeNewHead', subscribeNewHead)
  }
};
exports.default = _default;